import type { PointNumber, ResolveFn } from '../types.js';

export function placePayout(stake: number, n: PointNumber): number {
  if (n === 4 || n === 10) return Math.floor(stake * 9 / 5);
  if (n === 5 || n === 9) return Math.floor(stake * 7 / 5);
  return Math.floor(stake * 7 / 6);
}

export const resolvePlace: ResolveFn = (b, roll) => {
  if (b.number === undefined) {
    throw new Error('place bet missing number');
  }
  if (roll.total === b.number) {
    return { betId: b.id, outcome: 'win', payout: placePayout(b.amount, b.number) };
  }
  if (roll.total === 7) {
    return { betId: b.id, outcome: 'lose', payout: 0 };
  }
  return { betId: b.id, outcome: 'continue', payout: 0 };
};
